import { useEffect } from 'react'
import { useToolkitsStore } from 'react-toolkits'
import { serviceSchema } from '../schemas'
import { getStoreData, setStoreData } from '../stores'
import { replaceValueWithJMESPath } from '../utils'
import { withParsedData } from './base'

export const ServiceRenderer = withParsedData(serviceSchema)(({ parsedData }) => {
  const { storeId, params, url, body, storeIdRef, method } = parsedData
  const { axios } = useToolkitsStore(s => s)

  useEffect(() => {
    const storeData = getStoreData(storeIdRef)
    const newParams = params && replaceValueWithJMESPath(storeData, params)
    const newBody = params && replaceValueWithJMESPath(storeData, body)

    axios
      .request({
        method,
        url,
        params: newParams,
        data: newBody,
      })
      .then(res => {
        if (storeId) {
          setStoreData(storeId, res.data.data)
        }
      })
      .catch(err => {
        console.error(err)
      })
  }, [])

  return null
})
